module.exports = __webpack_public_path__ + "img/qrcode.4d76702f.jpg";